<template>
  <div class="item-tree" @click.stop="$emit('select', item)">
    <div class="item-tree-title" :class="{parent: !item.children || item.children.length < 0}">
      <div>
        <hs-business-icon :OrderBusinessType="item.OrderBusinessType" />
        {{item.title}}
      </div>
      <hs-button v-if="!item.children || item.children.length <= 0" class="btn" type="light-theme" height="28px" :fontSize="null" @click="$emit('select', item)">
        {{item.OrderBusinessType === 17 ? $t('GoEnquiry') : $t('GoBook')}}
      </hs-button>
    </div>
    <template v-if="item.children && item.children.length > 0">
      <div class="item-tree-cell" v-for="(child, childIndex) in item.children" :key="`child${childIndex}`">
        <div>{{child.title}}</div>
        <hs-button class="btn" type="light-theme" height="28px" :fontSize="null" @click="$emit('select', child)">
          {{child.OrderBusinessType === 17 ? $t('GoEnquiry') : $t('GoBook')}}
        </hs-button>
      </div>
    </template>
  </div>
</template>
<script type="text/ecmascript-6">
import HsBusinessIcon from "@/base/hs-tableview/hs-icon/hs-business-icon.vue";
import HsButton from "@/base/hs-button/hs-button.vue";
export default {
  props: {
    item: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  components: {
    HsBusinessIcon,
    HsButton
  }
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
.item-tree
  width 100%
  border-radius 8px
  background $color_black_10
  margin-bottom 8px
  &:last-child
    margin-bottom 0
  >.item-tree-title
    @extend .flex-between
    width 100%
    min-height 44px
    padding 0 12px
    box-shadow 0px -0.5px 0px 0px #EEEDED inset
    &.parent
      min-height 56px
    &:last-child
      box-shadow none
    >div:first-child
      @extend .flex-start
      @extend .hs-font-subtitle-middle
      color $color_black_900
  >.item-tree-cell
    @extend .flex-between
    width calc(100% - 40px)
    min-height 44px
    padding 0 12px 0 0
    margin-left 40px
    box-shadow 0px -0.5px 0px 0px #EEEDED inset
    &:last-child
      box-shadow none
    >div:first-child
      @extend .flex-start
      @extend .hs-font-body
      color $color_black_800
  .btn
    background $color_black_0
</style>
